import { faBlackboard } from '@fortawesome/free-solid-svg-icons';
import React, { useContext, useState ,useEffect} from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from '../Context/AuthProvider';
import useAdmin from '../hooks/useAdmin';
import '../Layout/DashboardLayout.css';

import useSeller from '../hooks/useSeller';



const DashboardLayout = () => {
  const {user} = useContext(AuthContext)
  const [isAdmin] = useAdmin(user?.email)
  const [isSeller] = useSeller(user?.email)
 
  const location = useLocation();
const [activeLink, setActiveLink] = useState(null);

useEffect(() => {
  // Update the activeLink whenever the location changes
  setActiveLink(location.pathname);
}, [location]);

  



    return (
        <div>
           

            <div className="drawer drawer-mobile ">
  <input id="dashboard-drawer" type="checkbox" className="drawer-toggle " />
  <div className="drawer-content">
  <Outlet></Outlet>
  </div> 
  <div className="drawer-side ">
    <label htmlFor="dashboard-drawer" className="drawer-overlay"></label> 
    <ul className="menu p-4 w-80 bg-[#333333] text-white">
     

       
   
       
        {
        isAdmin ? <div>
          <li><p className='text-3xl font-semibold mb-6'>Reread</p></li>
          <li>
          <NavLink
            to='/dashboard/allseller'
            className={`hover:text-[#f44344] focus:text-[#ffffff] bg-transparent text-lg focus:bg-[#f44344] focus:shadow-2xl active:text-[#ffffff]  active:shadow-2xl ${
              activeLink === '/dashboard/allseller' ? 'active-link' : ''
            }`}
          >
            All Seller
          </NavLink>
        </li>
          <li className='my-2'>   <NavLink
            to='/dashboard/allbuyer'
            className={`hover:text-[#f44344] focus:text-[#ffffff] bg-transparent text-lg focus:bg-[#f44344] focus:shadow-2xl my-2 ${
              activeLink === '/dashboard/allbuyer' ? 'active-link' : ''
            }`}
          >
            All Buyer
          </NavLink></li>
          <li> <NavLink
            to='/dashboard/reporteditems'
            className={`hover:text-[#f44344] focus:text-[#ffffff] bg-transparent text-lg focus:bg-[#f44344] focus:shadow-2xl ${
              activeLink === '/dashboard/reporteditems' ? 'active-link' : ''
            }`}
          >
            Reported Items
          </NavLink></li>
        
      </div>
      :
     
        isSeller ?
        <>
        
        <li><p className='text-3xl font-semibold mb-6'>Reread</p></li>
        
        <li> <NavLink to='/dashboard/mybook' className={`hover:text-[#f44344] focus:text-[#ffffff] bg-transparent text-lg focus:bg-[#f44344] focus:shadow-2xl active:text-[#ffffff]  active:shadow-2xl ${
              activeLink === '/dashboard/mybook' ? 'active-link' : ''
            }`}>My Books</NavLink></li>
         <li className='my-2'> <NavLink to='/dashboard/addbook' className={`hover:text-[#f44344] focus:text-[#ffffff] bg-transparent text-lg focus:bg-[#f44344] focus:shadow-2xl active:text-[#ffffff]  active:shadow-2xl ${
              activeLink === '/dashboard/addbook' ? 'active-link' : ''
            }`}>Add Book</NavLink></li>
        
         
        </> :<>
        <li><p className='text-3xl font-semibold mb-6'>Reread</p></li>
        <li> <Link to='/dashboard/myorder' className={`hover:text-[#f44344] focus:text-[#ffffff] bg-transparent text-lg focus:bg-[#f44344] focus:shadow-2xl active:text-[#ffffff]  active:shadow-2xl ${
              activeLink === '/dashboard/myorder' ? 'active-link' : ''
            }`}>MyOrders</Link></li>
        </>
      
      }
    
     
      
    </ul>
  
  </div>
</div>

        </div>
    );
};

export default DashboardLayout;